class CornerAcutality {
  constructor() {
    this._init();
  }
  _init() {
    // 1. Récupérer les éléments du DOM
    // On utilise un "type assertion" (<HTMLSelectElement>) pour que TypeScript sache
    // que ces éléments sont bien des listes déroulantes.
    const communeSelect = document.getElementById(
      'commune-select'
    ) as HTMLSelectElement;
    const categorySelect = document.getElementById(
      'category-select'
    ) as HTMLSelectElement;

    // Vérification de sécurité : s'assurer que les éléments existent avant d'aller plus loin
    if (!communeSelect || !categorySelect) {
      // console.error(
      //   "Impossible de trouver les éléments 'commune-select' ou 'category-select'."
      // );
      return; // Arrête l'exécution du script si un élément manque
    }

    // 2. Fonction pour recharger la page avec les filtres
    const reloadPageWithFilters = () => {
      // Récupère les valeurs actuelles des deux select
      const communeValue = communeSelect.value;
      const categoryValue = categorySelect.value;

      // Utilise l'API URLSearchParams pour construire proprement les paramètres de l'URL
      const params = new URLSearchParams(window.location.search);

      // Met à jour les paramètres. Si la valeur est vide, le paramètre est ajouté sans valeur (ex: ?commune=)
      // ce qui est souvent interprété comme "pas de filtre".
      params.set('commune', communeValue);
      params.set('category', categoryValue);

      // Reconstruit l'URL complète et redirige
      // window.location.pathname -> /ma-page.html
      // params.toString() -> commune=paris&category=restaurants
      window.location.href = `${window.location.pathname}?${params.toString()}`;
    };

    // 3. Attacher les écouteurs d'événements
    communeSelect.addEventListener('change', reloadPageWithFilters);
    categorySelect.addEventListener('change', reloadPageWithFilters);
  }
}
export const cornerAcutality = new CornerAcutality();
